import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "page-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-chevron-left",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "15 6 9 12 15 18" })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "container-fluid" }
const _hoisted_6 = { class: "page-header" }
const _hoisted_7 = { class: "row align-items-center" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "page-pretitle" }, " Overview ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "page-title" }, "QBricks Splitpanes", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "page-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container-fluid" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row row-deck row-cards" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "card-body p-2 text-center" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "text-end text-green" }, [
              /*#__PURE__*/_createElementVNode("span", { class: "text-green d-inline-flex align-items-center lh-1" }, [
                /*#__PURE__*/_createTextVNode(" 6% "),
                /*#__PURE__*/_createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "icon ms-1",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  "stroke-width": "2",
                  stroke: "currentColor",
                  fill: "none",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  /*#__PURE__*/_createElementVNode("path", {
                    stroke: "none",
                    d: "M0 0h24v24H0z",
                    fill: "none"
                  }),
                  /*#__PURE__*/_createElementVNode("polyline", { points: "3 17 9 11 13 15 21 7" }),
                  /*#__PURE__*/_createElementVNode("polyline", { points: "14 7 21 7 21 14" })
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "h1 m-0" }, "43"),
            /*#__PURE__*/_createElementVNode("div", { class: "text-muted mb-3" }, "New Tickets")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "card-body p-2 text-center" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "text-end text-green" }, [
              /*#__PURE__*/_createElementVNode("span", { class: "text-green d-inline-flex align-items-center lh-1" }, [
                /*#__PURE__*/_createTextVNode(" 23% "),
                /*#__PURE__*/_createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "icon ms-1",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  "stroke-width": "2",
                  stroke: "currentColor",
                  fill: "none",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  /*#__PURE__*/_createElementVNode("path", {
                    stroke: "none",
                    d: "M0 0h24v24H0z",
                    fill: "none"
                  }),
                  /*#__PURE__*/_createElementVNode("polyline", { points: "3 17 9 11 13 15 21 7" }),
                  /*#__PURE__*/_createElementVNode("polyline", { points: "14 7 21 7 21 14" })
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "h1 m-0" }, "$23,432.59"),
            /*#__PURE__*/_createElementVNode("div", { class: "text-muted mb-3" }, "Income")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "card-body p-2 text-center" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "text-end text-red" }, [
              /*#__PURE__*/_createElementVNode("span", { class: "text-red d-inline-flex align-items-center lh-1" }, [
                /*#__PURE__*/_createTextVNode(" -2% "),
                /*#__PURE__*/_createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "icon ms-1",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  "stroke-width": "2",
                  stroke: "currentColor",
                  fill: "none",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  /*#__PURE__*/_createElementVNode("path", {
                    stroke: "none",
                    d: "M0 0h24v24H0z",
                    fill: "none"
                  }),
                  /*#__PURE__*/_createElementVNode("polyline", { points: "3 7 9 13 13 9 21 17" }),
                  /*#__PURE__*/_createElementVNode("polyline", { points: "21 10 21 17 14 17" })
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "h1 m-0" }, "95"),
            /*#__PURE__*/_createElementVNode("div", { class: "text-muted mb-3" }, "Daily Earnings")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "card-body p-2 text-center" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "text-end text-green" }, [
              /*#__PURE__*/_createElementVNode("span", { class: "text-green d-inline-flex align-items-center lh-1" }, [
                /*#__PURE__*/_createTextVNode(" 9% "),
                /*#__PURE__*/_createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "icon ms-1",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  "stroke-width": "2",
                  stroke: "currentColor",
                  fill: "none",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  /*#__PURE__*/_createElementVNode("path", {
                    stroke: "none",
                    d: "M0 0h24v24H0z",
                    fill: "none"
                  }),
                  /*#__PURE__*/_createElementVNode("polyline", { points: "3 17 9 11 13 15 21 7" }),
                  /*#__PURE__*/_createElementVNode("polyline", { points: "14 7 21 7 21 14" })
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "h1 m-0" }, "7"),
            /*#__PURE__*/_createElementVNode("div", { class: "text-muted mb-3" }, "New Replies")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
            /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Social Media Traffic")
          ]),
          /*#__PURE__*/_createElementVNode("table", { class: "table card-table table-vcenter" }, [
            /*#__PURE__*/_createElementVNode("thead", null, [
              /*#__PURE__*/_createElementVNode("tr", null, [
                /*#__PURE__*/_createElementVNode("th", null, "Network"),
                /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "Visitors")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("tbody", null, [
              /*#__PURE__*/_createElementVNode("tr", null, [
                /*#__PURE__*/_createElementVNode("td", null, "Instagram"),
                /*#__PURE__*/_createElementVNode("td", null, "3,550"),
                /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "progress progress-xs" }, [
                    /*#__PURE__*/_createElementVNode("div", {
                      class: "progress-bar bg-primary",
                      style: {"width":"71.0%"}
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("tr", null, [
                /*#__PURE__*/_createElementVNode("td", null, "Twitter"),
                /*#__PURE__*/_createElementVNode("td", null, "1,798"),
                /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "progress progress-xs" }, [
                    /*#__PURE__*/_createElementVNode("div", {
                      class: "progress-bar bg-primary",
                      style: {"width":"35.96%"}
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("tr", null, [
                /*#__PURE__*/_createElementVNode("td", null, "Facebook"),
                /*#__PURE__*/_createElementVNode("td", null, "1,245"),
                /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "progress progress-xs" }, [
                    /*#__PURE__*/_createElementVNode("div", {
                      class: "progress-bar bg-primary",
                      style: {"width":"24.9%"}
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("tr", null, [
                /*#__PURE__*/_createElementVNode("td", null, "TikTok"),
                /*#__PURE__*/_createElementVNode("td", null, "986"),
                /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "progress progress-xs" }, [
                    /*#__PURE__*/_createElementVNode("div", {
                      class: "progress-bar bg-primary",
                      style: {"width":"19.72%"}
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("tr", null, [
                /*#__PURE__*/_createElementVNode("td", null, "Pinterest"),
                /*#__PURE__*/_createElementVNode("td", null, "854"),
                /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "progress progress-xs" }, [
                    /*#__PURE__*/_createElementVNode("div", {
                      class: "progress-bar bg-primary",
                      style: {"width":"17.08%"}
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("tr", null, [
                /*#__PURE__*/_createElementVNode("td", null, "VK"),
                /*#__PURE__*/_createElementVNode("td", null, "650"),
                /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "progress progress-xs" }, [
                    /*#__PURE__*/_createElementVNode("div", {
                      class: "progress-bar bg-primary",
                      style: {"width":"13.0%"}
                    })
                  ])
                ])
              ]),
              /*#__PURE__*/_createElementVNode("tr", null, [
                /*#__PURE__*/_createElementVNode("td", null, "Pinterest"),
                /*#__PURE__*/_createElementVNode("td", null, "420"),
                /*#__PURE__*/_createElementVNode("td", { class: "w-50" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "progress progress-xs" }, [
                    /*#__PURE__*/_createElementVNode("div", {
                      class: "progress-bar bg-primary",
                      style: {"width":"8.4%"}
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("footer", { class: "footer footer-transparent text-center" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Made with "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-vue" }, "♥"),
    /*#__PURE__*/_createTextVNode(" by "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://github.com/schodevio",
      target: "_blank",
      rel: "noopener",
      class: "author"
    }, "schodevio")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Pane = _resolveComponent("Pane")!
  const _component_Splitpanes = _resolveComponent("Splitpanes")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navbar),
    _createVNode(_component_Splitpanes, {
      onResized: _ctx.handleResized,
      class: "default-theme"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Pane, {
          size: _ctx.sidebarSize,
          "data-size": _ctx.sidebarSize,
          class: _normalizeClass({ 'is-closed': !_ctx.sidebarOpen })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Sidebar)
          ]),
          _: 1
        }, 8, ["size", "data-size", "class"]),
        _createVNode(_component_Pane, {
          size: _ctx.pageSize,
          "data-size": _ctx.pageSize,
          class: _normalizeClass({ 'is-wide': !_ctx.sidebarOpen }),
          "min-size": "50"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args))),
                class: _normalizeClass(['btn btn-icon splitpanes__toggler', { 'is-closed': !_ctx.sidebarOpen }])
              }, _hoisted_4, 2),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _hoisted_10,
                      _renderSlot(_ctx.$slots, "default")
                    ])
                  ])
                ]),
                _hoisted_11
              ]),
              _hoisted_12
            ])
          ]),
          _: 3
        }, 8, ["size", "data-size", "class"])
      ]),
      _: 3
    }, 8, ["onResized"])
  ]))
}